import Swiper from "swiper/bundle";

import "swiper/css/bundle";

export default () => {
  new Swiper(".style", {
    loop: true,
    slidesPerView: 1.4,
    spaceBetween: 10,
    centeredSlides: true,
    mousewheel: {
      forceToAxis: true,
      sensitivity: 1,
    },
    navigation: {
      prevEl: ".button-prev",
      nextEl: ".button-next",
    },
    on: {
      init: function () {
        const customIndex = ((this.realIndex - 3 + 3) % 3) + 1;
        document.getElementById(
          "slide-counter"
        ).textContent = `${customIndex}/3`;
      },
      slideChange: function () {
        const customIndex = ((this.realIndex - 3 + 3) % 3) + 1;
        document.getElementById(
          "slide-counter"
        ).textContent = `${customIndex}/3`;
      },
    },
    breakpoints: {
      768: {
        spaceBetween: 40,
      },
    },
  });

  new Swiper(".interview-swiper", {
    slidesPerView: 1,
    spaceBetween: 24,
    loop: true,
    navigation: {
      nextEl: ".interview-next",
      prevEl: ".interview-prev",
    },
  });
};
